<script setup lang="ts">
import { computed } from "vue";
import { UiLinkButton } from "@shopexperts/shared";
import type { UiIconProps } from "@shopexperts/shared";

const props = withDefaults(defineProps<{
    label: string;
    icon: UiIconProps["name"];
    tone?: "default" | "primary" | "warn" | "danger";
}>(), {
    tone: "default",
});

defineEmits<{
    (e: "click"): void;
}>();

const toneClass = computed(() => {
    const tone = (() => {
        switch (props.tone) {
            case "primary":
                return "hover:text-se-primary";
            case "warn":
                return "hover:text-amber-700";
            case "danger":
                return "hover:text-red-600";
            default:
                return "hover:text-se-gray-700";
        }
    })();

    return `${tone} !mx-0 shrink-0 !px-3`;
});
</script>

<template>
    <UiLinkButton
        variant="ghost"
        hover-decoration="underline"
        text-variant="p-small"
        :label="label"
        :icon="icon"
        :class="toneClass"
        @click="$emit('click')"
    />
</template>
